import { ABOUT } from "../../data/portfolio";
import { Heading, Row } from "./Primitives";

export default function AboutOutput() {
  return (
    <div>
      <Heading>whoami</Heading>
      {ABOUT.bio.map((line, i) => (
        <div key={i} className="text-neutral-300">{line || "\u00A0"}</div>
      ))}
      <div className="mt-3 space-y-0.5">
        {ABOUT.facts.map(([k, v]) => (
          <Row key={k} label={k}>{v}</Row>
        ))}
      </div>
    </div>
  );
}